<template>
<vs-row vs-type="flex" vs-w="12" :class="{'kiosk-product-page': isKiosk}">
    <mobile-order
      :orderListIsActive="orderListIsActive"
      @close="orderListIsActive = false"
      @emitRefresh="updateOrderQuantity"
      ref="mobileOrder"
    />
    <vs-row vs-type="flex" vs-w="12" v-if="!lossMode" class="px-4 py-2">
      <vs-col vs-type="flex" vs-w="12">
        <vs-input
          id="productSearchFilter"
          v-model="productSearchFilter"
          class="w-full bg-white"
          icon-pack="feather"
          icon="icon-search"
          placeholder="Ürün veya kategori ara..."
        />
      </vs-col>
    </vs-row>
    <vs-row vs-type="flex" vs-w="12" v-if="!lossMode">
      <vs-col vs-type="flex" vs-w="10" class="pl-2">
        <vs-button
          type="gradient"
          @click="onClickBreadCrumb(data, index)"
          class="breadCrumb-item px-3 my-1 mx-1"
          :color="index == currentBreadCrumbIndex ? 'primary' : 'secondary'"
          :class="index == currentBreadCrumbIndex ? '' : 'text-light'"
          icon-pack="feather"
          icon-after
          icon="icon-chevrons-right"
          v-for="(data, index) in breadCrumbItems"
          :key="data.id"
        >
          {{ data.name }}
        </vs-button>
      </vs-col>
    </vs-row>
    <vs-row v-else vs-type="flex" vs-w="12">
      <vs-row vs-tpye="flex" vs-w="12" vs-justify="space-between">
        <vs-col
          vs-type="flex"
          vs-w="9"
          vs-justify="flex-start"
          vs-align="center"
          class="pt-5 pl-6"
        >
          <span
            v-if="lossTypeSelection"
            class="text-dark text-medium-small2 weight-600"
          >
            Zayi Seçim Ekranı
          </span>
          <vs-button
            v-else
            type="gradient"
            @click="onClickBreadCrumb(data, index)"
            class="breadCrumb-item px-3"
            :color="index == currentBreadCrumbIndex ? 'primary' : 'secondary'"
            :class="index == currentBreadCrumbIndex ? '' : 'text-light'"
            icon-pack="feather"
            icon-after
            icon="icon-chevrons-right"
            v-for="(data, index) in breadCrumbItems"
            :key="data.id"
          >
            {{ data.name }}
          </vs-button>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-w="3"
          vs-justify="flex-end"
          vs-align="center"
          class="pt-5 pr-3"
        >
          <vs-button
            @click="lossMode = false"
            color="white"
            class="text-dark sale-box-shadow half-friendly-border"
            size="small"
            icon-pack="feather"
            icon="icon-arrow-left"
          >
            Satışa Geri Dön
          </vs-button>
        </vs-col>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12">
        <vs-col
          vs-type="flex"
          vs-w="12"
          vs-justify="flex-start"
          vs-align="center"
          class="pl-5"
        >
          <div class="btn-group">
            <vs-button
              @click="lossTypeSelection = true"
              type="line"
              class="mr-1"
              :class="{
                'clicked-line-button bold text-primary weight-600':
                  lossTypeSelection,
                'text-dark': !lossTypeSelection,
              }"
            >
              Zayi Hammadde Seçimi</vs-button
            >
            <vs-button
              @click="lossTypeSelection = false"
              type="line"
              class="ml-1"
              :class="{
                'clicked-line-button bold text-primary weight-600':
                  !lossTypeSelection,
                'text-dark': lossTypeSelection,
              }"
            >
              Zayi Ürün Seçimi</vs-button
            >
          </div>
        </vs-col>
      </vs-row>
    </vs-row>

    <vs-row
      ref="productCategoryList"
      :vs-w="isKiosk ? 12 : 10"
      vs-type="flex"
      id="dataList"
      :class="{ 
        maxDataListHeight: !lossMode, 
        maxDataListHeightLess: lossMode,
        'kiosk-data-list': isKiosk
      }"
      vs-justify="center"
      v-if="!(lossMode && lossTypeSelection) && !productDetailActive"
    >
      <vs-col vs-type="flex" vs-w="12" v-if="filteredProductList.length == 0">
        <p class="p-5 text-lg text-primary">Ürün Bulunamadı.</p>
      </vs-col>
      <vs-button
        class="vx-col sm:w-1/2 md:w-1/2 category-product m-1 responsive premium-card"
        :class="{
          'lg:w-1/4': isKiosk || imageEnabled,
          'lg:w-1/3 category-product-no-image': !isKiosk && !imageEnabled,
          'kiosk-product-card': isKiosk
        }"
        @click="onProductDetailClick(product)"
        color="transparent"
        v-for="product in filteredProductList"
        :key="product.id"
      >
        <vs-row vs-type="flex" vs-w="12">
          <vs-row v-if="imageEnabled" vs-type="flex" vs-w="12">
            <vs-col vs-type="flex" vs-w="12" vs-justify="center">
              <div class="flex items-center justify-center p-3 card-image-container">
                <img
                  :src="
                    product.imageUrl
                      ? $baseUrl + '/' + product.imageUrl
                      : productPlaceHolder
                  "
                  class="responsive product-img"
                />
              </div>
            </vs-col>
          </vs-row>
          <vs-row
            vs-type="flex"
            vs-w="12"
            class="category-product-name-row py-3"
            :class="{ 'py-6': !imageEnabled, 'bg-white rounded-b-lg': true }"
          >
            <vs-col vs-type="flex" vs-w="12" vs-justify="center" class="flex-column">
              <p
                class="text-smaller block text-primary weight-700 category-product-name px-2"
                :class="{
                  'text-lg': !imageEnabled,
                  'long-text': isLongProductName(product.name)
                }"
              >
                {{ product.name }}
              </p>
              <p
                class="text-lg italic block text-success bold px-2 mt-2 font-display"
                v-if="checkChildren(product) != null"
              >
                {{ checkChildren(product) }}
              </p>
            </vs-col>
          </vs-row>
        </vs-row>
      </vs-button>
    </vs-row>

    <vs-row vs-type="flex" vs-w="0.75" v-if="!isKiosk && !(lossMode && lossTypeSelection)">
      <vs-button
        @click="openMobileOrders"
        type="gradient"
        class="w-full bg-primary2 text-light mb-3"
        icon-pack="feather"
        icon="icon-list"
        color="transparent"
      >
        <!-- Siparişler -->
      </vs-button>
      <vs-col vs-type="flex" vs-w="12" vs-align="center">
        <div class="w-full">
          <vs-button
            @click="scrollTop"
            type="gradient"
            class="w-full bg-primary2 text-light mb-3"
            icon-pack="feather"
            icon="icon-chevron-up"
            color="transparent"
          />
          <vs-button
            @click="scrollDown"
            type="gradient"
            class="w-full bg-primary2 text-light mt-3"
            icon-pack="feather"
            icon="icon-chevron-down"
            color="transparent"
          />
        </div>
      </vs-col>
    </vs-row>

    <vs-row
      vs-type="flex"
      vs-w="12"
      v-if="lossMode && lossTypeSelection"
      class="px-6 pt-3"
    >
      <vs-row vs-type="flex" vs-w="12" class="pb-3">
        <vs-col vs-type="flex" vs-w="12" class="px-1">
          <vs-input
            id="saleStockFilter"
            v-model="stockNameFilter"
            class="w-full bg-white"
            icon-pack="feather"
            icon="icon-search"
            placeholder="Stok İsmi"
          />
        </vs-col>
      </vs-row>
      <vs-row
        id="cartStockNameList"
        vs-type="flex"
        vs-w="12"
        v-if="stocks.length > 0"
      >
        <vs-row
          class="cartLossStockNameEntry"
          v-show="!stock.isSelected"
          :class="{
            'bg-secondary2': indextr % 2 == 0,
            'bg-white2': indextr % 2 == 1,
          }"
          vs-type="flex"
          vs-w="12"
          v-for="(stock, indextr) in filteredStocks"
          :key="stock.id"
        >
          <vs-col
            vs-type="flex"
            vs-w="7"
            vs-align="center"
            vs-justify="flex-start"
          >
            <span class="text-dark text-smaller weight-600">
              {{ stock.name }}
            </span>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-w="2"
            vs-align="center"
            vs-justify="flex-start"
          >
            <span class="text-dark text-smaller weight-600">
              {{ stock.unit.name }}
            </span>
          </vs-col>
          <vs-col vs-type="flex" vs-w="2" vs-align="center">
            <vs-input
              :name="stock.id + '.Miktar'"
              :disabled="stock.isSelected"
              size="small"
              v-validate="{ regex: /^\d{0,10}(\.\d{0,10}){0,1}$/ }"
              v-model="stock.quantity"
              class="w-full"
              placeholder="Miktar"
            />
            <span
              class="text-danger text-xsmall"
              v-show="errors.has(stock.id + '.Miktar')"
              >{{ "Geçersiz Format" }}</span
            >
          </vs-col>
          <vs-col vs-type="flex" vs-w="1" vs-align="center" vs-justify="center">
            <vs-button
              v-if="
                stock.quantity != null &&
                stock.quantity > 0 &&
                !stock.isSelected
              "
              radius
              @click="setStockSelect(stock)"
              size="small"
              type="filled"
              color="success"
              icon-pack="feather"
              icon="icon-check"
            />
          </vs-col>
        </vs-row>
      </vs-row>
    </vs-row>
  </vs-row>
</template>
<script>
import { getLossStockNameList } from "@/api/Loss.js";
import MobileOrder from "./MobileOrder.vue";
import { GetMobileOrderQuantity } from "@/api/ProductCategory.js";
export default {
  components: {
    MobileOrder,
  },
  data() {
    return {
      productPlaceHolder: require("@/assets/images/products/product-kahve.png"),
      breadCrumbItems: [],
      currentBreadCrumbIndex: 0,
      breadCrumbId: 0,
      productDetailActive: false,
      stocks: [],
      stockNameFilter: null,
      filteredStocks: [],
      newOrder: false,
      orderQuantity: 0,
      orderListIsActive: false,
      productSearchFilter: '',
    };
  },
  props: {
    productList: null,
    imageEnabled: false,
    isKiosk: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasNeedNavigationByQuestion() {
      return this.$store.getters["selfservice/hasNeedNavigationByQuestion"];
    },
    hasAnySelectedStockLoss() {
      let bool = this.stocks.some((x) => x.isSelected);
      return !bool;
    },
    lossTypeSelection: {
      get() {
        return this.$store.getters["selfservice/getLossType"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setLossType", val);
      },
    },
    selectedLossStocks() {
      return this.$store.getters["selfservice/getSelectedLossStocks"];
    },
    lossMode: {
      get() {
        return this.$store.getters["selfservice/getLossMode"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setLossMode", val);
      },
    },
    currentCart: function () {
      return this.$store.getters["selfservice/getCurrentCart"];
    },
    isReset: {
      get() {
        return this.$store.getters["selfservice/getToIsReset"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setIsReset", val);
      },
    },
    currentProductList() {
      if (this.productList != null) {
        const products = this.breadCrumbItems.length > 0
          ? this.breadCrumbItems[this.currentBreadCrumbIndex].dataSet
          : [];

        // v113: A-Z Sıralama (Türkçe karakter desteği ile)
        return [...products].sort((a, b) => a.name.localeCompare(b.name, 'tr'));
      } else {
        return [];
      }
    },
    isScreenLock: {
      get() {
        return this.$store.getters["selfservice/getScreenLock"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setScreenLock", val);
      },
    },
    filteredProductList() {
      if (!this.productSearchFilter) {
        return this.currentProductList;
      }

      // v113: Global Arama (Tüm ağaçta ara)
      const filter = this.productSearchFilter.toLowerCase();
      const results = [];

      const traverse = (items) => {
        if (!items) return;
        for (const item of items) {
          if (item.name.toLowerCase().includes(filter)) {
            results.push(item);
          }
          if (item.childCategories) traverse(item.childCategories);
          if (item.products) traverse(item.products);
        }
      };

      traverse(this.productList);

      // Tekilleştir ve A-Z sırala
      const uniqueResults = [...new Map(results.map(i => [i.id + (i.type || 'cat'), i])).values()];
      return uniqueResults.sort((a, b) => a.name.localeCompare(b.name, 'tr'));
    },
  },
  watch: {
    hasNeedNavigationByQuestion(val) {
      if (val) {
        this.navigateByQuestion();
      }
    },
    productSearchFilter(val) {
      // Search is handled by computed property filteredProductList
    },
    stockNameFilter(val) {
      this.setStockFilter(val);
    },
    lossMode(val) {
      if (val) {
        if (this.stocks.length > 0) return;
        this.getLossStockNameList();
      }
    },
    isReset(val) {
      if (!val) return;
      this.$store.dispatch("selfservice/removeCart", this.currentCart.id);
      this.$store.dispatch("selfservice/setSelectedProduct", null);
      this.$store.dispatch("selfservice/setPreSelectedProduct", null);
      this.$store.dispatch("selfservice/setToUpdateEntry", null);
      this.$store.dispatch("selfservice/clearSelectedLossStocks");
      this.lossTypeSelection = true;
      this.onClickBreadCrumb(this.breadCrumbItems[0], 0);
      if (this.stocks.length > 0) {
        this.stocks.forEach((x) => {
          x.quantity = null;
          x.isSelected = false;
        });
      }
      this.isReset = false;
    },
    selectedLossStocks: {
      deep: true,
      handler(val) {
        let selectedStocks = this.stocks.filter((x) => x.isSelected);
        if (val && val.length == 0) {
          selectedStocks.forEach((x) => {
            x.isSelected = false;
            x.quantity = null;
          });
        } else if (
          val &&
          val.length > 0 &&
          val.length < selectedStocks.length
        ) {
          selectedStocks.forEach((x) => {
            if (!val.some((y) => y.id == x.id)) {
              x.isSelected = false;
              x.quantity = null;
            }
          });
        }
      },
    },
  },
  created: async function () {
    // Get the initial order quantity
    this.updateOrderQuantity();
  },
  inject: [
    "refreshOrderQuantity",
    "getOrderQuantity",
    "hasNewOrder",
    "resetNewOrder",
  ],
  mounted: function () {
    // Initialize component without creating a new SignalR connection
    this.initializeComponent();
  },
  methods: {
    updateOrderQuantity: async function () {
      // Use the injected method
      await this.refreshOrderQuantity();
      this.orderQuantity = await this.getOrderQuantity();
      this.newOrder = this.hasNewOrder();
    },
    openMobileOrders() {
      this.resetNewOrder();
      this.newOrder = false;
      this.orderListIsActive = true;
      if (this.$refs.mobileOrder) {
        try {
          this.$refs.mobileOrder.getOrder();
        } catch (error) {
          console.error("Error calling getOrder:", error);
          this.$vs.notify({
            color: "danger",
            title: "Hata!",
            text: "Siparişler yüklenirken bir sorun oluştu.",
          });
        }
      } else {
        console.error("mobileOrder reference is not available");
        this.$vs.notify({
          color: "danger",
          title: "Hata!",
          text: "Sipariş komponenti bulunamadı.",
        });
      }
    },
    setStockSelect(stock) {
      stock.isSelected = true;
      this.$store.dispatch("selfservice/addSelectedLossStock", stock);
    },
    setStockFilter: _.debounce(function (val) {
      this.filteredStocks = this.stocks.filter((x) =>
        x.name.toLowerCase().includes(val.toLowerCase())
      );
    }, 500),
    getLossStockNameList() {
      getLossStockNameList()
        .then((res) => {
          if (res && res.status) {
            this.stocks = res.data;
            this.setStockFilter("");
          } else {
            this.$fire({
              title: "Hata : " + res.status,
              text: "Stok Listesi Bulunamadı !",
              type: "error",
            });
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Stok Listesi Bulunamadı !",
            });
          }
        })
        .catch((error) => {
          this.$fire({
            title: "Hata !",
            text: "Sunucuya Bağlantı Hatası !",
            type: "error",
          });
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucuya Bağlantı Hatası !",
          });
        });
    },
    scrollTop() {
      let element = document.getElementById("dataList");
      element.scrollBy(0, -100);
    },
    scrollDown() {
      let element = document.getElementById("dataList");
      element.scrollBy(0, 100);
    },
    checkChildren: function (product) {
      if (product.children) {
        if (product.children.length == 1 && product.children[0].recipe) {
          return product.children[0].price.toString() + "₺";
        }
      }
      return null;
    },

    initializeComponent: async function () {
      this.breadCrumbItems = [
        {
          name: "Kategoriler",
          id: this.breadCrumbId++,
          dataSet: this.productList,
        },
      ];
    },
    navigateByQuestion() {
      let navigationQuestion =
        this.$store.getters["selfservice/getNavigationQuestion"];
      this.onClickBreadCrumb(this.breadCrumbItems[0], 0);
      if (navigationQuestion.categoryId) {
        let category = this.currentProductList.find(
          (x) => x.id === navigationQuestion.categoryId
        );
        this.onProductDetailClick(category);
        this.$store.dispatch("selfservice/setCurrentCartNavigatedByQuestion");
      }

      if (navigationQuestion.productId) {
        let product = this.currentProductList.find(
          (x) => x.id === navigationQuestion.productId
        );
        this.onProductDetailClick(product);
        this.$store.dispatch("selfservice/setCurrentCartNavigatedByQuestion");
      }
    },
    onClickBreadCrumb: function (selectedBreadCrumb, index) {
      this.currentBreadCrumbIndex = index;
      this.breadCrumbItems.length = this.currentBreadCrumbIndex + 1;
      this.breadCrumbItems = [...this.breadCrumbItems];
    },
    onProductDetailClick: function (product) {
      let breadItem = {
        id: this.breadCrumbId++,
        name: product.name,
      };

      if (product.children) {
        if (product.children.length == 1 && product.children[0].recipe) {
          product.children[0].isSelected = true;
          this.$store.dispatch("selfservice/productSelectionCompleted", {
            product: product,
            sizeId: product.children[0].sizeId,
          });
          return;
        }
      }

      if (product.childCategories != null) {
        breadItem.dataSet = product.childCategories;
        this.breadCrumbItems.push(breadItem);
        this.currentBreadCrumbIndex++;
      } else if (product.products != null) {
        breadItem.dataSet = product.products;
        this.breadCrumbItems.push(breadItem);
        this.currentBreadCrumbIndex++;
      } else if (product.type) {
        this.SelectProduct(product);
      }
    },
    SelectProduct: function (product) {
      this.$store.dispatch("selfservice/setPreSelectedProduct", product);
    },
    isLongProductName: function (name) {
      return name.length > 20;
    },
  },
};
</script>
<style>
.cartLossStockNameEntry .vs-inputx {
  border: none !important;
  border-bottom: 1px solid #00000030 !important;
  border-radius: 0;
  background-color: transparent !important;
  font-weight: 600;
}

.cartLossStockNameEntry {
  border-bottom: 1px solid #00000020;
  padding: 0.5rem;
}

.breadCrumb-item {
  font-weight: 600 !important;
  font-size: 1.15rem !important;
}

#cartStockNameList {
  max-height: 73vh;
  overflow-y: auto;
  border-radius: 1rem;
  border: 1px solid #00000040;
}

#cartStockNameList::-webkit-scrollbar {
  width: 0;
  height: 0;
}

#dataList {
  overflow: scroll;
  margin-left: 20px;
}

.maxDataListHeightLess {
  max-height: 83.25vh;
}

.maxDataListHeight {
  max-height: 85vh;
}

#dataList::-webkit-scrollbar {
  height: 0 !important;
  width: 0 !important;
}
.category-product-name {
  word-wrap: break-word;
  word-break: break-word;
  hyphens: auto;
  line-height: 1.2;
  font-size: 0.875rem;
  max-height: none;
}

.category-product-name.long-text {
  font-size: 0.75rem;
}

.category-product-no-image .category-product-name {
  font-size: 1rem !important;
  line-height: 1.2;
  word-wrap: break-word;
  word-break: break-word;
}

.category-product-no-image .category-product-name.long-text {
  font-size: 0.875rem !important;
}

.category-product .vs-button--text {
  display: inline !important;
}
.category-product {
  max-width: 175px;
  border-radius: 18px;
  padding: 0 !important;
  border: 1px solid #00000050;
}
.category-product-no-image {
  min-height: 100px;
}

.category-product-no-image .category-product-name-row {
  min-height: 100px;
  display: flex;
  align-items: center;
}

.category-product-no-image .category-product-name {
  font-size: 1rem !important;
  line-height: 1.2;
}

.category-product img {
  max-width: 135px !important;
  max-height: 135px !important;
}

.scroll-buttons-col {
  height: fit-content;
  margin-top: auto;
  margin-bottom: auto;
}

.clicked-line-button .vs-button-linex {
  width: 100% !important;
}

#product-list {
  z-index: 20;
}
.premium-card {
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  box-shadow: 0 4px 6px rgba(0,0,0,0.06) !important;
  border: none !important;
  background: white !important;
  overflow: hidden;
  border-radius: 20px !important;
}

.premium-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 15px 30px rgba(0,0,0,0.1) !important;
}

.kiosk-product-card {
  max-width: 280px !important;
  min-height: 320px !important;
}

.kiosk-product-card .category-product-name {
  font-size: 1.6rem !important;
  line-height: 1.1;
  font-weight: 800 !important;
}

.kiosk-product-card .category-product-name.long-text {
  font-size: 1.3rem !important;
}

.kiosk-product-page .breadCrumb-item {
  font-size: 1.5rem !important;
  padding: 18px 36px !important;
}

.kiosk-product-card .text-success {
  font-size: 1.8rem !important;
}

.card-image-container {
  background: #fdfdfd;
  width: 100%;
}

.product-img {
  max-width: 180px !important;
  max-height: 180px !important;
  object-fit: contain;
  filter: drop-shadow(0 5px 15px rgba(0,0,0,0.05));
}

.font-display {
  font-family: 'Outfit', 'Inter', sans-serif !important;
}

.kiosk-data-list {
  padding: 2rem !important;
  background: #fafafa !important;
}

.category-product-name-row {
  border-top: 1px solid #f5f5f5 !important;
}

.flex-column {
  flex-direction: column;
}

#productSearchFilter .vs-input--input {
  height: 65px !important;
  font-size: 1.3rem !important;
  border-radius: 35px !important;
  box-shadow: 0 6px 15px rgba(0,0,0,0.04) !important;
  border: 1px solid #eee !important;
  padding-left: 60px !important;
  background: white !important;
}

#productSearchFilter .vs-input--icon {
  font-size: 1.6rem !important;
  top: 20px !important;
  left: 20px !important;
  color: #666;
}

.breadCrumb-item {
  border-radius: 30px !important;
  text-transform: none !important;
  letter-spacing: 0.5px;
  padding: 14px 28px !important;
  box-shadow: 0 4px 10px rgba(0,0,0,0.08) !important;
  font-size: 1.1rem !important;
  margin: 0.5rem !important;
}

.text-medium-small2 {
  font-size: 1.1rem;
}

.weight-700 {
  font-weight: 700;
}

.swal2-container {
  z-index: 99999;
}
</style>
